import React, { useRef, useState, useEffect } from "react";
import { Box, Typography, IconButton, useMediaQuery } from "@mui/material";
import { ArrowBackIos, ArrowForwardIos } from "@mui/icons-material";
import { motion, AnimatePresence } from "framer-motion";
import { useTranslation } from "react-i18next";
import "../../styles/_aboutWithGallery.scss";

const AboutWithGallerySection = () => {
  const { t, i18n } = useTranslation();
  const scrollRef = useRef(null);

  const isMobile = useMediaQuery("(max-width:600px)");
  const [activeIndex, setActiveIndex] = useState(0);

  const galleryImages = [
    "/images/2.png",
    "/images/3.png",
    "/images/4.png",
    "/images/5.png",
    "/images/6.png",
    "/images/gurudev.png",
  ];

  const scroll = (direction) => {
    if (!scrollRef.current) return;
    const scrollAmount = scrollRef.current.clientWidth * 0.6;
    scrollRef.current.scrollBy({
      left: direction === "left" ? -scrollAmount : scrollAmount,
      behavior: "smooth",
    });
  };

  const scrollToIndex = (index) => {
    if (!scrollRef.current) return;
    scrollRef.current.scrollTo({
      left: scrollRef.current.clientWidth * index,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    if (!scrollRef.current) return;
    const container = scrollRef.current;

    const handleScroll = () => {
      const width = container.clientWidth;
      const index = Math.round(container.scrollLeft / width);
      setActiveIndex(index);
    };

    container.addEventListener("scroll", handleScroll);
    return () => container.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <Box className="about-gallery-section">
      {/* LEFT CONTENT */}
      <Box className="left-content">
        <AnimatePresence mode="wait">
          <motion.div
            key={i18n.language}
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: 20 }}
            transition={{ duration: 0.6 }}
          >
            <Typography variant="h3" className="title">
              {t("about.title")}
            </Typography>
            <Typography className="description">
              {t("about.description")}
            </Typography>
          </motion.div>
        </AnimatePresence>
      </Box>

      {/* RIGHT GALLERY */}
      <Box className="gallery-wrapper">
        {/* DESKTOP ARROWS */}
        {!isMobile && (
          <IconButton className="arrow-btn left" onClick={() => scroll("left")}>
            <ArrowBackIos />
          </IconButton>
        )}

        <Box className="right-gallery">
          <div ref={scrollRef} className="gallery-scroll">
            {galleryImages.map((img, i) => (
              <motion.img
                key={i}
                src={img}
                alt={`Gallery ${i}`}
                className="gallery-image"
                whileHover={{ scale: 1.05 }}
                transition={{ duration: 0.3 }}
                loading="lazy"
              />
            ))}
          </div>

          {/* MOBILE DOTS */}
          {isMobile && (
            <div className="mobile-dots">
              {galleryImages.map((_, i) => (
                <span
                  key={i}
                  className={`dot ${activeIndex === i ? "active" : ""}`}
                  onClick={() => scrollToIndex(i)}
                />
              ))}
            </div>
          )}
        </Box>

        {!isMobile && (
          <IconButton className="arrow-btn right" onClick={() => scroll("right")}>
            <ArrowForwardIos />
          </IconButton>
        )}
      </Box>
    </Box>
  );
};

export default AboutWithGallerySection;